class QrUrlFormatter {
  static shortenUrl(url) {
    return url.replace(/^(https?:\/\/(www\.)?|www\.)/, "")
  }

  static expandUrl(url) {
    return `https://${url}`
  }

  static getSubdomain(url) {
    return `${url.split(".com")[0]}.com`
  }
  static getSubdomainEnding(url) {
    return url.split(".com").pop()
  }
}

export default QrUrlFormatter
